<template>
  <div id="no_result_found">
    <p>{{title}}</p>
  </div>
</template>

<script>
export default {
  name: "NoResult",
  props: ["title"]
};
</script>

<style>
</style>